import styled from "styled-components";

export const StyledImageWrapper = styled.div<{ size: number }>`
  position: relative;
  flex-shrink: 0;
  ${({ size }) => `
    height: ${size}px;
    width: ${size}px;
  `}
`;
